import { render, staticRenderFns } from "./colors-dialog.vue?vue&type=template&id=7d5f65ce&"
import script from "./colors-dialog.vue?vue&type=script&lang=js&"
export * from "./colors-dialog.vue?vue&type=script&lang=js&"
import style0 from "./colors-dialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports